module.exports = "pegasus/assets/background-patterns/other-theme.png";